import React from 'react'
import { BdaServiceApplicationProperty, BdaServiceProperty, BdaServiceResourceProperty } from '../../models/BdaService'
import InputTokenizer from '../generics/InputTokenizer';
import { Input, Slider } from 'antd';
import { setObjectType } from '../../utils';
import ScriptEditor from '../common/ScriptEditor';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

type Props = {
  prop: BdaServiceProperty;
  onPropChange: (key: string, checkbox?: boolean, pure?: boolean) => (evt: any) => void;
  onBlur?: VoidFunction;
  updateServiceProperties?: VoidFunction;
  wideMode?: boolean;
}

const sliderFormatter = (prop: BdaServiceResourceProperty) => (value?: number) => `${value}${prop.metricUnit}`;

export default function ServicePropertyFormItem({ prop, onPropChange, onBlur, updateServiceProperties, wideMode }: Props) {
  const environmentVariables = useSelector((state: RootState) => state.designer.environmentVariables);

  if (prop.interpolationEnabled) return (
    <InputTokenizer
      placeholder={prop.defaultValue || `${prop.key} value`}
      value={prop.value || ""}
      onChange={onPropChange(prop.key!, false, true)}
      onBlur={onBlur}
      variables={environmentVariables}
    />
  )

  if (prop.key === window.__env.DESIGNER__AGENT_PROMPT_PROPERTY) return (
    <Input.TextArea
      value={prop.value || ""}
      placeholder={prop.defaultValue || `${prop.key} value`}
      onChange={onPropChange(prop.key!)}
      onBlur={onBlur}
    />
  )

  if (prop.type === 'resource' && setObjectType<BdaServiceResourceProperty>(prop)) return (
    <div className="px-2">
      <Slider
        step={prop.step}
        value={prop.value}
        defaultValue={prop.defaultValue}
        min={prop.allowedRange?.min}
        max={prop.allowedRange?.max}
        marks={{
          [prop.allowedRange?.min || '0']: <span>{prop.allowedRange?.min || '0'}{prop.metricUnit}</span>,
          [prop.allowedRange?.max || '100']: <span>{prop.allowedRange?.max || '100'}{prop.metricUnit}</span>
        }}
        tooltip={{ formatter: sliderFormatter(prop) }}
        onChange={onPropChange(prop.key!, false, true)}
        onChangeComplete={updateServiceProperties}
      />
    </div>
  )

  return prop.valueType === "JSON"
    ? (
      <ScriptEditor
        height={wideMode ? 450 : 150}
        value={prop.value || prop.defaultValue || ""}
        onChange={onPropChange(prop.key!, false, true)}
        onBlur={updateServiceProperties}
      />
    )
    : (prop as BdaServiceApplicationProperty).obfuscated
      ? (
        <Input.Password
          value={prop.value || ""}
          placeholder={prop.defaultValue || `${prop.key} value`}
          onChange={onPropChange(prop.key!)}
          onBlur={onBlur}
        />
      )
      : (
        <Form.Control
          size="sm"
          type={prop.valueType === 'INT' ? 'number' : 'text'}
          placeholder={prop.defaultValue || `${prop.key} value`}
          value={prop.value || ""}
          onChange={onPropChange(prop.key!)}
          onBlur={onBlur}
        />
      )
}